import vxlColors from 'shared/styles/color/core';

const dataVis = {
  purple: vxlColors.core.purple[500],
  lavender: vxlColors.core.expressive.lavender[500],
  eggplant: vxlColors.core.expressive.eggplant[500],
  lime: vxlColors.core.expressive.lime[500],
  green: '#52c72c',
  mint: vxlColors.core.expressive.mint[500],
  sunset: vxlColors.core.expressive.sunset[500],
  pink: '#fe6fac',
  orange: '#f59249',
};

export default dataVis;
